import { Component, OnDestroy, OnInit } from '@angular/core';
import { WorkOrderMaterial } from './work-order-material.model';
import { WorkOrderMaterialService } from './work-order-material.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { getCurrentWorkOrder } from '@app/core/store/selectors/work-order.selector';
import { LoadWorkOrder } from '@dwo/actions';

@Component({
  selector: 'app-work-order-materials',
  templateUrl: './work-order-materials.component.html',
  styleUrls: ['./work-order-materials.component.scss'],
  standalone: false,
})
export class WorkOrderMaterialsComponent implements OnInit, OnDestroy {
  public materials: WorkOrderMaterial[] = [];
  private destroy$ = new Subject<void>();
  groupedMaterials: any[] = [];
  constructor(
    private workOrderMaterialsService: WorkOrderMaterialService,
    private store: Store,
    private route: ActivatedRoute,
  ) {
    this.workOrderMaterialsService
      .getData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((materials) => {
        this.materials = materials ?? [];
        this.groupMaterials();
      });
  }

  ngOnInit() {
    this.store
      .select(getCurrentWorkOrder)
      .pipe(takeUntil(this.destroy$))
      .subscribe((workorder) => {
        if (!workorder) {
          const workOrderId = this.route.parent?.parent?.snapshot.paramMap.get('id') ?? '';
          this.store.dispatch(new LoadWorkOrder(workOrderId));
        }
      });
  }

  groupMaterials() {
    this.groupedMaterials = [];
    const map = new Map();
    for (const mat of this.materials ?? []) {
      if (!map.has(mat.materialNumber)) {
        map.set(mat.materialNumber, { ...mat, quantity: 0, items: [] });
      }
      const group = map.get(mat.materialNumber);
      group.quantity += mat.quantity;
      group.items.push(mat);
    }
    this.groupedMaterials = Array.from(map.values()).sort((a, b) => a.materialNumber.localeCompare(b.materialNumber));
    this.groupedMaterials.forEach((group) => (group.expanded = true));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
